// TODO refactor all functions and dependencies to sit in this common folder outside
// of site and design system so they can be used anywhere.
import LOCALES from '../locales/locales.json';

const pageTypeTranslations = {};
LOCALES.forEach(locale => {
  pageTypeTranslations[
    locale.code
  ] = require(`../locales/${locale.code}/page-type-translations.json`);
});

export function getBaseUrl(localeCode = 'en-GB') {
  if (localeCode === 'en-GB') {
    return '/';
  }
  return `/${localeCode.slice(0, 2)}/`;
}

export function getTranslatedPageTypeSlug(localeCode, pageType) {
  const translatedPageType = pageTypeTranslations[localeCode][pageType]
    ? pageTypeTranslations[localeCode][pageType].pageTypeUrl
    : pageType;
  const standalonePageTypes = ['basic', 'standard'];
  const translatedPageTypeSlug = standalonePageTypes.includes(
    translatedPageType
  )
    ? ''
    : `${translatedPageType}/`;
  return translatedPageTypeSlug;
}

export function generateUrl(localeCode, pageType, slug) {
  const baseUrl = getBaseUrl(localeCode);
  const translatedPageTypeSlug = getTranslatedPageTypeSlug(
    localeCode,
    pageType
  );
  const url = baseUrl + translatedPageTypeSlug + slug;
  return url;
}

export function generateStructureUrl(localeCode, structureType, structureSlug) {
  return generateUrl(localeCode, structureType, structureSlug);
}

export function generateSubPageUrl(
  localeCode,
  structureType,
  structureSlug,
  subPageSlug
) {
  return `${generateStructureUrl(
    localeCode,
    structureType,
    structureSlug
  )}/${subPageSlug}`;
}

// Can't use module.exports here as
// ES Modules may not assign module.exports or exports.*, Use ESM export syntax, instead
// module.exports = {
//   generateStructureUrl,
//   generateSubPageUrl,
//   generateUrl,
//   getBaseUrl,
//   getTranslatedPageTypeSlug,
// };
